import React, { Component } from 'react';
import { AutoForm } from 'uniforms-material';
import Dialog from '@material-ui/core/Dialog/index';
import DialogTitle from '@material-ui/core/DialogTitle/index';
import DialogContent from '@material-ui/core/DialogContent/index';
import DialogActions from '@material-ui/core/DialogActions/index';
import Button from '@material-ui/core/Button';
class DialogEdit extends Component {
    constructor() {
        super(...arguments);
        this.formRef = React.createRef();
        this.state = {
            open: false,
            titleDialog: this.props.lang === 'fr' ? 'Ajouter' : 'Add',
            modelValues: {},
            schema: null,
        };
        this.handleCloseForm = () => {
            this.setState({ open: false });
        };
        this.handleOpenForm = (newState) => {
            this.setState({ open: true, ...newState });
        };
        this.handleSubmit = () => {
            this.formRef.current.submit();
        };
    }
    render() {
        const { fullScreenDialog = false, title, onSubmit, lang, classesCollectionManager = 'react-collection-manager', dialogEditDisableEnforceFocus = false, } = this.props;
        const { open, titleDialog, modelValues, schema } = this.state;
        if (!open)
            return null;
        if (!schema) {
            console.error('You must pass a valid schema to react-collection-manager');
            return null;
        }
        const Component = this.props.components && this.props.components.form ? this.props.components.form : AutoForm;
        return (React.createElement(Dialog, { fullScreen: fullScreenDialog, open: open, maxWidth: 'lg', fullWidth: true, onClose: this.handleCloseForm, disableEnforceFocus: dialogEditDisableEnforceFocus },
            React.createElement(DialogTitle, null, `${titleDialog} ${title}`),
            React.createElement(DialogContent, null,
                React.createElement(Component, { ref: this.formRef, schema: schema, model: modelValues, submitField: () => null, onSubmit: onSubmit, placeholder: true, name: title, id: "addList", className: classesCollectionManager })),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: this.handleCloseForm }, lang === 'fr' ? 'Annuler' : 'Cancel'),
                React.createElement(Button, { color: "primary", onClick: this.handleSubmit }, lang === 'fr' ? 'Enregistrer' : 'Submit'))));
    }
}
export default DialogEdit;
